import React from 'react';
import { Route } from 'react-router-dom';

import type { ICreditBureauActivity } from '../types/ICreditBureauActivity';
import { getAllRoutes } from '../utils/routes';
import CreditBureauActivity from './CreditBureauActivity';
import { MAX_APP_CONTAINER_WIDTH_NEW } from '@makemydeal/dr-shared-ui-utils';

const Root = (props: ICreditBureauActivity) => {
    const { root } = getAllRoutes(props.baseRoute);

    return (
        <div
            style={{ maxWidth: MAX_APP_CONTAINER_WIDTH_NEW, margin: '0 auto', padding: '0 16px' }}
            data-testid="activities-credit-bureau-container"
            className="activities-credit-bureau"
        >
            <Route path={root} component={CreditBureauActivity} />
        </div>
    );
};

Root.displayName = 'CreditBureauActivity';

export default Root;
